<template>
   <div
      id='material-partners'
      :class='breakpoint'>
      <div :class='containerClass'>
         <div
            id='partners-content'
            :class='breakpoint'>
            <h1 class='text-center'>Findforsikring.dk samarbejder med flg. forsikringsselskaber</h1>
            <div
               id='partner-logos'
               class='d-flex'
               style='margin-top: 2em; align-items: center'>
               <img
                  v-for='logo in logos'
                  v-bind='logo.style'
                  :key='logo.file'
                  :src='logo.url'
                  :alt='logo.file'
                  class='partner-logo' />
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
   name: 'MaterialPartners',
   data() {
      return {
         logoData: [
            {
               file: 'abc',
               style: {
                  width: 200,
                  height: 34
               }
            },
            {
               file: 'alka',
               style: {
                  width: 105,
                  height: 45
               }
            },
            {
               file: 'almbrand',
               style: {
                  width: 60,
                  height: 60
               }
            },
            {
               file: 'aros',
               style: {
                  width: 65,
                  height: 60
               }
            },
            {
               file: 'codan',
               style: {
                  width: 179,
                  height: 35
               }
            },
            {
               file: 'dansk_boligforsikring',
               style: {
                  width: 136,
                  height: 55
               }
            },
            {
               file: 'ditforsikringshus',
               style: {
                  // width: 136,
                  height: 55
               }
            },
            {
               file: 'gfforsikring',
               style: {
                  width: 80,
                  height: 55
               }
            },
            {
               file: 'topdanmark-min',
               style: {
                  width: 220,
                  height: 50
               }
            },
            {
               file: 'coopforsikringer',
               style: {
                  width: 204,
                  height: 55,
                  style: { marginTop: 'calc(1.5em + 10px)' }
               }
            },
            {
               file: 'gjensidige-min',
               style: {
                  width: 200,
                  height: 50
               }
            },
            // {
            //    file: 'pensam',
            //    style: {
            //       width: 164,
            //       height: 55,
            //    },
            // },
            // {
            //    file: 'global-min',
            //    style: {
            //       width: 168,
            //       height: 50,
            //    },
            // },
            {
               file: 'dfa',
               style: {
                  width: 96,
                  height: 45
               }
            },
            {
               file: 'if',
               ext: 'svg',
               style: {
                  width: 70,
                  height: 70
               }
            },
            {
               file: 'tryg',
               style: {
                  width: 116,
                  height: 50
               }
            },
            {
               file: 'fdm',
               ext: 'svg',
               style: {
                  width: 150,
                  height: 50
               }
            },
            {
               file: 'storstroems_forsikring',
               ext: 'svg',
               style: {
                  width: 150,
                  height: 50
               }
            },
            {
               file: 'lokal',
               style: {
                  width: 97,
                  height: 60
               }
            },
            {
               file: 'forsia',
               style: {
                  width: 173,
                  height: 60
               }
            }

            // {
            //    file: 'sonderjysk-cropped',
            //    style: {
            //       width: 150,
            //       height: 70,
            //    },
            // },
         ]
      };
   },
   computed: {
      ...mapGetters(['breakpoint', 'containerClass', 'width']),
      logos() {
         let ext = this.$store.state.imageExtension;
         console.log('ext', ext);
         if (ext === 'jpg') {
            ext = 'png';
         }
         return this.logoData.map((item) => {
            const path = `/landing-assets/images/${item.file}.${item.ext || ext}`;
            // const path = import()
            return {
               ...item,
               url: path
            };
         });
      }
   }
};
</script>

<style lang='scss' scoped>
//noinspection CssUnknownTarget
@import '~/colors.scss';

#material-partners {
   background-color: $ff-stripe-bg;
   font-size: 17px;
   color: $ff-dark-blue;

   &.sm {
      font-size: 15px;
   }

   &.xs {
      font-size: 13px;
   }

   #partners-content {
      padding: 3em 1em;
   }

   #partner-logos {
      overflow-x: hidden;
      --logo-margin: 1.75em;
      flex-wrap: wrap;
      justify-content: center;
      margin-top: 2em;
      margin-left: -1.75em;
      margin-right: -1.75em;

      .partner-logo {
         margin: 1.75em;
      }
   }
}
</style>
